import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-loading3",
  "use": "icon-loading3-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-loading3\">\n<circle cx=\"3.5\" cy=\"8\" r=\"1.5\" fill=\"#26AB38\" />\n<circle opacity=\"0.5\" cx=\"8\" cy=\"8\" r=\"1.5\" fill=\"#26AB38\" />\n<circle opacity=\"0.25\" cx=\"12.5\" cy=\"8\" r=\"1.5\" fill=\"#26AB38\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol